export const appLocal = 'http://localhost:8000/api/'
export const appServer = 'https://mehriranianco.ir/api/'
export const appDomainServer = 'https://panel.mehriranianco.ir/'
export const appDomainLocal = 'http://localhost:3011/'

